import { render, staticRenderFns } from "./DocumentDebtor.vue?vue&type=template&id=54e5997d&scoped=true&"
import script from "./DocumentDebtor.vue?vue&type=script&lang=js&"
export * from "./DocumentDebtor.vue?vue&type=script&lang=js&"
import style0 from "./DocumentDebtor.vue?vue&type=style&index=0&id=54e5997d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54e5997d",
  null
  
)

export default component.exports